
export const LOGO = "https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png";
export const BACKGROUND_IMG= "https://assets.nflxext.com/ffe/siteui/vlv3/dae1f45f-c2c5-4a62-8d58-6e1b0c6b2d8e/6d1fb8a4-5844-42a4-9b01-1c6c128acf19/IN-en-20240827-TRIFECTA-perspective_WEB_c292a608-cdc6-4686-8dc8-405bfcf753af_small.jpg"
export const AVATAR = "https://occ-0-6246-2186.1.nflxso.net/dnm/api/v6/vN7bi_My87NPKvsBoib006Llxzg/AAAABUMx6z-7bB7tyN-OZXt6i8BXuZHN5EWBr7MQy7ilhubrpI2yOofVtT-QmoO6VJt7I1ewosmuQa29BGFfOOVcJxdKx1sT-co.png?r=201"

export const API_OPTIONS = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJiNzI0NWUyMjJhMDhlNjM0NTg3MDg4ZTVhNjllNjA0MSIsIm5iZiI6MTcyNjMzNDk1MS42NTEzODYsInN1YiI6IjY2NjUzZDY0OGJjNjUzNDRjMDljZjg2YyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.OwTJWlcc8DcXZNtNPMT-VqpB9JKZXCAw9BrGvTKUdlA'
    }
  };


  export const IMAGE_URL = "https://image.tmdb.org/t/p/w500/"  
  
  export const MOVIE_PAGE_URL = "https://api.themoviedb.org/3/movie/"


  export const SUPPORTED_LANG = [
                                  {
                                    identifier : "en-US",
                                    name      :  "English"
                                  },
                                  {
                                    identifier : "hindi",
                                    name      :  "Hindi"
                                  },
                                  {
                                    identifier : "spanish",
                                    name      :  "Spanish"
                                  },
                                
                                ]

  export const OPEN_AI_KEY = process.env.REACT_APP_OPENAI_KEY
  export const OPEN_AI_PROJECT_ID=process.env.REACT_APP_OPENAI_PROJECT_ID
  export const OPEN_AI_ORG_ID = process.env.REACT_APP_OPEN_AI_ORG_ID